import { Route } from 'vue-router';

import { baseFilters } from './baseFilters';

/**
 * Filtry partnerów
 *
 * @export
 * @param {Route} route
 * @returns
 */
export function benefitFilters(route: Route, filters?: any) {
  route.query.order = 'name';
  return { ...baseFilters(route, 12), state: 'ACTIVE', partnerState: 'ACTIVE', ...filters };
}
